export const userTheadArr = [
  { title: "번호", width: "8%", key: "no" },
  { title: "아이디", width: "10%", key: "id" },
  { title: "이름", width: "10%", key: "name" },
  { title: "휴대폰 번호", width: "14%", key: "phone" },
  { title: "회사명", width: "14%", key: "company" },
  { title: "현장명", width: "14%", key: "location" },
  { title: "보고용 메일", width: "14%", key: "email" },
  { title: "탈퇴여부", width: "8%", key: "withdrawal" },
];

export const noticeTheadArr = [
  // { title: "체크", width: "8%", key: "check" },
  { title: "번호", width: "8%", key: "no" },
  { title: "제목", width: "48%", key: "title" },
  { title: "등록인", width: "12%", key: "userName" },
  { title: "날짜", width: "18%", key: "date" },
  { title: "조회", width: "14%", key: "lookup" },
];

export const materialTheadArr = [
  // { title: "체크", width: "6%", key: "check" },
  { title: "날짜", width: "10%", key: "date" },
  { title: "아이디", width: "10%", key: "id" },
  { title: "이름", width: "10%", key: "name" },
  { title: "회사명", width: "12%", key: "company" },
  { title: "현장명", width: "14%", key: "location" },
  { title: "작업명", width: "14%", key: "work" },
  { title: "PDF", width: "8%", key: "pdf" },
  { title: "녹음파일", width: "8%", key: "mp3" },
  { title: "메일전송", width: "8%", key: "mail" },
];